import React from 'react';
import CardDetails, { Card } from './CardDetails';

/**
 * Constants to ignore certain keys from the JSON
 * Only want to map the cards object
 */
const PAGE_TITLE = 'page_title';
const FOOTER = 'disclaimers';

interface CardListProps {
    cardData: Record<string, Card>; // key string, card object
}

/**
 * cardData prop must be passed in
 * Filters all the keys that are NOT credit cards (using constants above)
 * cardObjects map the filtered keys to their corresponding card objects
 * For each card object, returns renders a NewCard component
 */
const CardList: React.FC<CardListProps> = ({ cardData }) => {
    const cardKeys = Object.keys(cardData).filter(
        (key) => key !== PAGE_TITLE && key !== FOOTER,
    );

    const cardObjects = cardKeys.map((key) => cardData[key]);

    return (
        <>
            {cardObjects.map((card) => (
                <CardDetails key={card.salesProductCode} card={card} />
            ))}
        </>
    );
};

export default CardList;
